export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=35cdb87a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/list.vue?vue&type=template&id=35cdb87a&scoped=true
// module id = Wmv1
// module chunks = 0